// src/features/landing/infrastructure/landingStaticRepository.js

/** @type {import("../domain/heroSlide").HeroSlide[]} */
const HERO_SLIDES = [
    {
        id: 1,
        title: "Rising Brokers",
        subtitle: "보험 인력 시장의 새로운 기준",
        description: "보험사와 GA, 그리고 GA 전문 인력이 모두 함께 성장하는 구조를 설계합니다.",
        buttonText: "라이징 브로커즈 소개",
        image: "/images/slide_11.png",
        targetId: "/about",
    },
    {
        id: 2,
        title: "세상의 모든 중개",
        subtitle: "프리미엄 보험 전문 헤드헌팅",
        description: "GA 매니저·총무 채용을 위한 검증된 인재 Pool과 체계적인 매칭 프로세스를 제공합니다.",
        buttonText: "제공 서비스 안내",
        image: "/images/landing_5.png",
        targetId: "/service",
    },
    {
        id: 3,
        title: "검증된 인재, 안정적인 정착",
        subtitle: "3개월 보장제 맞춤 교육 진행",
        description: "채용 이후의 정착과 성장까지 책임지는 파트너십을 지향합니다.",
        buttonText: "파트너십 문의",
        image: "/images/slide_12.png",
        targetId: "/contact",
    },
];

const SIGNATURE_ITEMS = [
    {
        id: 1,
        label: "Brokers Signature 01",
        title: "전문 인력 발굴",
        description: [
            "인바운드(SNS, 커뮤니티) + 아웃바운드(헤드헌팅 네트워크) 병행",
            "GA 매니저 및 총무 중심의 전문 인력 Pool 확보",
            "업계 출신 리크루터가 직접 1차 인터뷰 및 평판 검증",
        ],
    },
    {
        id: 2,
        label: "Brokers Signature 02",
        title: "역량 기반 Pool 분류",
        description: [
            "경력, 업무지식, CS마인드, 성향 등 정량·정성 평가",
            "등급으로 분류하여 조직별 니즈에 맞게 추천",
            "검증된 인력만 공급하는 구조로 채용 리스크 최소화",
        ],
    },
    {
        id: 3,
        label: "Brokers Signature 03",
        title: "최적 매칭 및 정착 지원",
        description: [
            "회사별 상품 특성, 문화, 지역, 보상체계까지 고려한 매칭",
            "3개월 Replacement 보장제 시행으로 조기 이탈 리스크 제로화",
            "입사 후 초기 적응 교육, 관리자 커뮤니케이션 지원",
        ],
    },
];


/** @type {import("../domain/serviceStep").ServiceStep[]} */
const SERVICE_STEPS = [
    {
        order: 1,
        title: "GA 전문 인력 후보자 발굴",
        descriptionLines: [
            "SNS, 커뮤니티, 추천, 헤드헌팅 네트워크 등 다양한 채널을 통해 GA 전문 인력 후보자를 소싱합니다.",
            "현장에서 바로 활용 가능한 실무형 인재 중심으로 Pool을 구성합니다.",
        ],
    },
    {
        order: 2,
        title: "심층 평가 및 Pool 분류",
        descriptionLines: [
            "이력·경력·업무지식·CS 마인드·성향 등에 대해 구조화된 인터뷰를 진행합니다.",
            "평판 체크를 통해 리스크 요인을 사전에 차단하고, 역량 수준에 따라 등급화합니다.",
        ],
    },
    {
        order: 3,
        title: "최적 매칭 및 정착 관리",
        descriptionLines: [
            "조직 구조, 상품 포트폴리오, 문화, 보상체계를 모두 고려하여 최적의 인력 매칭을 진행합니다.",
            "3개월간 Replacement 보장 및 초기 교육/커뮤니케이션을 통해 안착률을 높입니다.",
        ],
    },
];

/** @type {import("../domain/valuePoint").ValuePoint[]} */
const VALUE_POINTS = [
    {
        id: 1,
        title: "보험 업계 출신의 깊이 있는 이해",
        subtitle: "17년 이상의 보험사·GA 실무 경험",
        descriptionLines: [
            "대표 및 핵심 구성원이 보험사와 GA 현장을 모두 경험한 전문가들로 구성되어 있습니다.",
            "현장에서 어떤 인력이 필요하고, 어떤 요소가 정착과 성과에 영향을 미치는지 정확히 알고 있습니다.",
        ],
    },
    {
        id: 2,
        title: "검증된 인력 품질과 보장제도",
        subtitle: "체계적인 평가와 3개월 Replacement",
        descriptionLines: [
            "단순 이력 검토가 아닌, 심층 인터뷰와 평판 체크를 기반으로 인재를 선별합니다.",
            "3개월 내 조기 이탈 시 Replacement를 보장하여 파트너사의 리스크를 최소화합니다.",
        ],
    },
    {
        id: 3,
        title: "운영 부담을 줄이는 유연한 구조",
        subtitle: "선지급형 / 분할형 정산 체계",
        descriptionLines: [
            "파트너사의 재무·운영 상황에 맞춘 수수료 정산 구조를 설계합니다.",
            "채용 관련 업무 부담을 줄여, 현장이 영업과 마케팅에 집중할 수 있도록 돕습니다.",
        ],
    },
];

/** @type {import("../domain/treatmentCategory").TreatmentCategory[]} */
const TREATMENT_CATEGORIES = [
    {
        id: 1,
        title: "채용 효율 극대화",
        items: [
            "채용 즉시 투입 가능한 실무형 인재 공급",
            "현장 교육 리소스 절감 및 업무 연속성 확보"
        ],
        image: "/images/treatment-1.jpg",
    },
    {
        id: 2,
        title: "품질 보장 및 리스크 제로화",
        items: [
            "3개월 Replacement 제도",
            "사전 처우 협의 완료 후 공급"
        ],
        image: "/images/treatment-2.jpg",
    },
    {
        id: 3,
        title: "여드름 클리닉",
        items: [
            "유연한 수수료 정산 체계(선지급형 / 분할형)",
            "세금계산서 프로세스 반영"
        ],
        image: "/images/treatment-3.jpg",
    },
    {
        id: 4,
        title: "보톡스 & 필러",
        items: [
            "사각턱 · 침샘 보톡스",
            "주름 & 스킨 보톡스",
            "페이스 필러 · 특수 부위 필러",
        ],
        image: "/images/treatment-4.jpg",
    },
    {
        id: 5,
        title: "리프팅 & 탄력",
        items: [
            "레이저 리프팅",
            "고주파 · 초음파 리프팅",
            "실 리프팅 프로그램",
        ],
        image: "/images/treatment-5.jpg",
    },
    {
        id: 6,
        title: "제모 & 스킨케어",
        items: [
            "레이저 제모 프로그램",
            "모공 · 피부결 케어",
            "피부 타입별 맞춤 스킨케어",
        ],
        image: "/images/treatment-6.jpg",
    },
];

/** @type {import("../domain/event").EventItem[]} */
const EVENTS = [
    {
        id: 1,
        month: "11월",
        title: "11월 프로모션 안내",
        description: "시즌에 맞는 시술 패키지를 합리적인 혜택으로 만나보세요.",
        image: "/images/event-11.jpg",
        status: "진행중",
    },
    {
        id: 2,
        month: "10월",
        title: "10월 이벤트",
        description: "기간 한정으로 진행된 스페셜 프로모션입니다.",
        image: "/images/event-10.jpg",
        status: "종료",
    },
    {
        id: 3,
        month: "9월",
        title: "9월 이벤트",
        description: "라디앙만의 시즌 케어 패키지를 만나보세요.",
        image: "/images/event-09.jpg",
        status: "종료",
    },
];

// Repository 객체
export const landingRepository = {
    getHeroSlides() {
        return HERO_SLIDES;
    },
    getSignatureItems() {
        return SIGNATURE_ITEMS;
    },
    getServiceSteps() {
        return SERVICE_STEPS;
    },
    getValuePoints() {
        return VALUE_POINTS;
    },
    getTreatmentCategories() {
        return TREATMENT_CATEGORIES;
    },
    getEvents() {
        return EVENTS;
    },
};
